import {action, computed, observable} from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    inject, ModalHandle, ServicesAlert,
} from 'Mri.Web.Common';
import * as React from 'react';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledButtonDropdown
} from 'reactstrap';
import {ActiveDisplay} from "../../ActiveDisplay";
import {TerminalModal} from "../../TerminalModal";
import {TicketModal} from "../../TicketModal";
import {DisplayEditModal} from "../../DisplayView/Settings/DisplayEditModal";
import {RdpLink} from "../../../Core/RdpLink";
import {LinkContainer} from "react-router-bootstrap";
import {AccountStore} from "../../../Account/AccountStore";
import {ContractsStore} from "../../../Contracts/ContractsStore";
import {AppStore} from "../../../Core/AppStore";
import {IDisplayFieldProps} from "./DisplayFields";
import { ContractModal } from '../../../Contracts/ContractModal';

@autoinject
@observer
export class SerialNumberFieldDropdown extends React.Component<IDisplayFieldProps> {
    public render() {
        if (!this.display) return null;
        
        return (
            <div className="d-flex align-items-center">
                <UncontrolledButtonDropdown isOpen={true}>
                    <DropdownMenu>
                        <DropdownItem
                            tag="a"
                            href={`${this.accountStore.portalUrl}/proxy/${this.display.serialNumber}`}
                            target={this.accountStore.user?.statusVuNewTab ? '_blank' : ''}
                            className={this.disabledClass}
                        >
                            StatusVu&reg;
                        </DropdownItem>

                        <DropdownItem onClick={this.openCreateTicketModal}>Create Ticket</DropdownItem>

                        <DropdownItem onClick={this.openDisplayEditModal}>Edit</DropdownItem>

                        <DropdownItem onClick={this.openContractModal}>View Contract</DropdownItem>

                        <DropdownItem
                            tag="a"
                            href={'/software-updates/manifests/' + this.display.serialNumber + '/create'}
                            target={''}
                            className={this.disabledClass}
                        >
                            Update Now
                        </DropdownItem>

                        <DropdownItem tag={RdpLink} type="input1" display={this.display}>
                            VNC Player 1
                        </DropdownItem>

                        <DropdownItem tag={RdpLink} type="input2" display={this.display}>
                            VNC Player 2
                        </DropdownItem>

                        <DropdownItem tag={RdpLink} type="camera" display={this.display}>
                            Camera IP
                        </DropdownItem>

                        <DropdownItem className={this.disabledClass} onClick={this.openTerminalModal}>
                            Terminal
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledButtonDropdown>
                
                <DisplayEditModal display={this.display} modalHandle={this.displayEditModalHandle} />
                
                {this.contract && (
                    <ContractModal
                        contract={this.contract}
                        display={this.display}
                        modalHandle={this.contractModalHandle}
                        viewState="readOnly"
                        
                    />
                )}
                
                <TicketModal display={this.display} modalHandle={this.createTicketModalHandle} />
                
                <TerminalModal modalHandle={this.terminalModalHandle} serialNumber={this.display.serialNumber} />
            </div>
        );
    }

    @bind
    @action
    private toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen;
        //this.props.vm.stickyColumnDropdownOpen = !this.props.vm.stickyColumnDropdownOpen;
    }

    @bind
    @action
    private openDisplayEditModal(event: React.MouseEvent<HTMLAnchorElement>) {
        event.preventDefault();
        this.renderModals = true;

        this.displayEditModalHandle.open();
    }

    @bind
    @action
    private openContractModal(event: React.MouseEvent<HTMLAnchorElement>) {
        event.preventDefault();
        this.renderModals = true;

        this.contractModalHandle.open();
    }

    @bind
    @action
    private openCreateTicketModal(event: React.MouseEvent<HTMLAnchorElement>) {
        event.preventDefault();
        this.renderModals = true;

        this.createTicketModalHandle.open();
    }

    @bind
    @action
    private openTerminalModal(event: React.MouseEvent<HTMLAnchorElement>) {
        event.preventDefault();
        this.renderModals = true;

        this.terminalModalHandle.open();
    }

    @computed
    private get disabledClass() {
        if (
            !this.display ||
            !this.display.displayConnectionData ||
            !this.display.displayConnectionData.displayBoardIP ||
            !this.display.displayConnectionData.nocServer
        ) {
            return 'disabled';
        } else return '';
    }

    @computed
    private get contract() {
        if(this.display)
        return this.contractsStore.contracts.get(this.display.contract);
    }

    @computed
    private get display() {
        return this.props.data;
    }

    @observable
    private renderModals = false;
    @observable
    private dropdownOpen = false;
    private displayEditModalHandle = new ModalHandle();
    private contractModalHandle = new ModalHandle();
    private createTicketModalHandle = new ModalHandle();
    private terminalModalHandle = new ModalHandle();
    @inject
    private accountStore!: AccountStore;
    @inject
    private appStore!: AppStore;
    @inject
    private contractsStore!: ContractsStore;
}
